import {
  audioMapper,
  basicScoreMapper,
  bonusInfoMapper,
  lessonMapper,
  pendingFutureSessionMapper,
  subunitsMapper,
  timelineAssignedMapper,
  unitsMapper,
  grammarSessionsMapper,
  wordImgMapper,
} from "../mappers/grammarMapper"
import provider from "./Provider"
import { errorHandler } from "./errorHandler"

export const getUnits = () => {
  return new Promise((resolve, reject) => {
    provider
      .get("/grammar/get-units")
      .then((response) => {
        resolve(unitsMapper(response))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const subunitsByUnits = (units_ids) => {
  return new Promise((resolve, reject) => {
    const DTO = { units_ids }
    provider
      .post("/grammar/get-subunits-by-units", DTO)
      .then((response) => {
        resolve(subunitsMapper(response))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const createGrammarLesson = (
  class_id,
  subunit_id,
  is_all_subunit,
  session_number,
  date,
  deadline,
  students,
  full_class
) => {
  return new Promise((resolve, reject) => {
    const DTO = {
      class_id,
      subunit_id,
      is_all_subunit,
      session_number,
      date,
      deadline,
      students,
      full_class,
    }
    provider
      .post("/grammar/create-grammar-lesson", DTO)
      .then((response) => {
        resolve(subunitsMapper(response))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getGrammarSessionsByClass = (class_id, automated = false) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/sessions-by-class/${class_id}/${automated}`)
      .then((response) => {
        resolve(grammarSessionsMapper(response, automated))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getStudentSessionAccuracy = (lesson_id, student_id) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/student-session-accuracy/${lesson_id}/${student_id}`)
      .then((response) => {
        resolve(basicScoreMapper(response))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getImageByParsedName = (parsed_name) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/app-student/vocabulary/images/${parsed_name}`)
      .then((response) => {
        resolve(wordImgMapper(response))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getStudentTotalSessionsAccuracy = (event_id, student_id) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/student-tot-sessions-accuracy/${event_id}/${student_id}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const previewLesson = (subunit_id, session_number, is_all_subunit) => {
  return new Promise((resolve, reject) => {
    const DTO = { subunit_id, session_number, is_all_subunit }
    provider
      .post("/grammar/preview-lesson", DTO)
      .then((response) => {
        resolve(lessonMapper(response))
      })
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getGrammarTextToSpeechGoogle = (word) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/app-student/grammar/text-to-speech-google/${word}`)
      .then((response) => resolve(audioMapper(response)))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const checkSessionAlreadyAssigned = (
  class_id,
  subunit_id,
  is_all_subunit,
  session_number,
  students,
  full_class
) => {
  const DTO = {
    class_id,
    subunit_id,
    is_all_subunit,
    session_number,
    students,
    full_class,
  }
  return new Promise((resolve, reject) => {
    provider
      .post("/grammar/check-session-already-assigned", DTO)
      .then((response) => resolve(response))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getPendingFutureSession = (student_id) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/pending-future-session/${student_id}`)
      .then((response) => resolve(pendingFutureSessionMapper(response)))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getTimelineAssigned = (student_id) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/timeline-assigned/${student_id}`)
      .then((response) => resolve(timelineAssignedMapper(response)))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getTimelineAutomated = (student_id) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/timeline-automated/${student_id}`)
      .then((response) => resolve(timelineAssignedMapper(response)))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getStudentCompletedSessions = (student_id) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/student-completed-sessions/${student_id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const getBonusInfo = (group_token) => {
  return new Promise((resolve, reject) => {
    provider
      .get(`/grammar/bonus-info/${group_token}`)
      .then((response) => resolve(bonusInfoMapper(response)))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}

export const deleteSession = (event_id) => {
  return new Promise((resolve, reject) => {
    provider
      .post("grammar/delete-session", { event_id })
      .then((response) => resolve(response))
      .catch((error) => {
        !errorHandler(error) && reject(error)
      })
  })
}
